import { render } from "./ResetPassword.vue?vue&type=template&id=72a12922"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script